<script setup lang="ts">
const emit = defineEmits<{
    (event: "locate-user"): void;
    (event: "zoom-in"): void;
    (event: "zoom-out"): void;
}>();
</script>

<template>
    <div class="interactieve-kaart__actions">
        <button
            type="button"
            class="btn interactieve-kaart__actions-button"
            aria-label="Toon mijn locatie"
            @click="emit('locate-user')"
        >
            <span class="icon icon-my-location"></span>
        </button>

        <button
            type="button"
            class="btn interactieve-kaart__actions-button"
            aria-label="Zoom uit"
            @click="emit('zoom-out')"
        >
            <span class="icon icon-minus"></span>
        </button>

        <button
            type="button"
            class="btn interactieve-kaart__actions-button"
            aria-label="Zoom in"
            @click="emit('zoom-in')"
        >
            <span class="icon icon-plus"></span>
        </button>
    </div>
</template>